/**
 * New typescript file
 */
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {PhotoService} from './service.photo';
//import {Router,RouteParams}  from '@angular/router';
import { TranslateService} from 'ng2-translate';
import { AuthService} from './service.auth';
import { CommonService} from './service.common';

@Component({
    selector: 'page-topbar',
    templateUrl: './html/pageTopbar.html'
})
export class PageTopbarComponent{
  constructor(
    private authService: AuthService,
    private commonService: CommonService,
    private photoService: PhotoService,
    private translateService: TranslateService,
    private router: Router
    ) { }
    
    ngOnInit(){
//      this.translateService.get('Login', {value: 'world'}).subscribe((res: string) => {
      
      let lang = this.commonService.currentLocale.language;
      document.querySelector('html').setAttribute('lang', lang);


    }
    public toggleHideFilter(): void{
        this.photoService.showFilter = ! this.photoService.showFilter;
    }
    changelang(lang: string): void{
      this.commonService.changeCurrentLocaleByLanguage(lang);
//      document.querySelector('html')?.setAttribute('lang', lang);
      document.querySelector('html').setAttribute('lang', lang);

    }
	  logout(): void {
      // this.translateService.use('cn');
      // let response = this.translateService.instant('Login');
      // console.log(response);
      // console.log(this.translateService.currentLang)
      //     console.log(this.translateService.get('Login'));

      this.translateService.get('Sure to logout').subscribe((res: string) => {
        //console.log(res);

        let question:string;
        question = res + '?';

        if(confirm(question)){
          this.authService.logout();

          localStorage.setItem("accountlogin", "false");


          localStorage.setItem("selflogout", "true");
          localStorage.setItem('showDonation', 'f');


          this.router.navigate(['/login']);
        }
   

      });


  
    }
}


// WEBPACK FOOTER //
// ./src/app/pageTopbar.ts